export enum ToastActions {
  add = 'add',
  remove = 'remove'
}

export type ToastAction = ToastActions.add | ToastActions.remove;
